import { matchPath } from "react-router-dom";
import routing from "routing";

export const unauthorizedPaths = [
	routing.paths.signIn,
	routing.paths.signUp,
	routing.paths.resetPassword,
	routing.paths.successResetPassword,
	routing.paths.setNewPassword,
	routing.paths.setPasswordError,
	routing.paths.chatWidget,
];

export default function useIsAuthPage() {
	return unauthorizedPaths.some((path) =>
		matchPath(top.location.pathname, {
			path: path,
			exact: true,
			strict: false,
		}),
	);
}
